import React from "react";
import { Box, Container, Grid, useTheme, alpha } from "@mui/material";
import HeroBackground from "./hero/HeroBackground";
import HeroContent from "./hero/HeroContent";
import HeroVisual from "./hero/HeroVisual";

const Hero: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{
        pt: { xs: 10, md: 12 },
        pb: { xs: 6, md: 8 },
        minHeight: { xs: "auto", md: "90vh" },
        display: "flex",
        alignItems: "center",
        background: `radial-gradient(circle at 30% 107%, ${alpha(theme.palette.primary.light, 0.08)} 0%, ${alpha(theme.palette.primary.main, 0.05)} 5%, ${alpha(theme.palette.primary.dark, 0.1)} 45%, ${theme.palette.background.default} 60%)`,
        position: "relative",
        overflow: "visible",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "5%",
          right: "5%",
          width: "50%",
          height: "50%",
          background: `radial-gradient(circle, ${alpha(theme.palette.secondary.light, 0.25)} 0%, ${alpha(theme.palette.secondary.light, 0)} 70%)`,
          zIndex: 0,
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: "5%",
          left: "5%",
          width: "30%",
          height: "30%",
          background: `radial-gradient(circle, ${alpha(theme.palette.primary.light, 0.18)} 0%, ${alpha(theme.palette.primary.light, 0)} 70%)`,
          zIndex: 0,
        },
        backgroundImage: `
          linear-gradient(${alpha(theme.palette.primary.main, 0.03)} 1px, transparent 1px),
          linear-gradient(90deg, ${alpha(theme.palette.primary.main, 0.03)} 1px, transparent 1px)
        `,
        backgroundSize: "20px 20px",
      }}
    >
      <HeroBackground theme={theme} />

      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <HeroContent />
          <HeroVisual theme={theme} />
        </Grid>
      </Container>
    </Box>
  );
};

export default Hero;
